import React from 'react';
import './Navigation.css';

export const TECHNICAL_ANALYSIS_TABS = [
  { id: 'ticker', label: 'Ticker', icon: '📊' },
  { id: 'dashboard', label: 'Daily Chart', icon: '🎯' },
  { id: 'hourly', label: 'Hourly Chart', icon: '📈' },
  { id: 'adx', label: 'ADX', icon: '📉' },
  { id: 'rsi', label: 'RSI', icon: '📊' },
  { id: 'macd', label: 'MACD', icon: '〰️' },
  { id: 'signals', label: 'Signals', icon: '🔔' },
];

export const TOP_LEVEL_TABS = [
  { id: 'investing', label: 'Stocks', icon: '📈' },
  { id: 'etp-prices', label: 'ETF', icon: '🪙' },
  { id: 'etn-prices', label: 'ETN', icon: '₿' },
  { id: 'etc-cot', label: 'ETC', icon: '🌾' },
  { id: 'fx', label: 'FX', icon: '💱' },
  { id: 'bond-investing', label: 'Macro Indicators', icon: '📊' },
  { id: 'contacts', label: 'Contact', icon: '✉️' },
];

export const MACRO_INDICATORS_TABS = [
  { id: 'bond-investing', label: 'Overview', icon: '📋' },
  { id: 'macro-stock-bond', label: 'Stock vs Bond', icon: '📈' },
  { id: 'macro-btc-nasdaq', label: 'BTC vs Nasdaq', icon: '₿' },
  { id: 'macro-gold-usd', label: 'Gold vs USD', icon: '🥇' },
  { id: 'macro-commodities', label: 'Commodities', icon: '🛢️' },
];

export const MACRO_INDICATORS_PAGES = new Set(MACRO_INDICATORS_TABS.map((t) => t.id));

const TA_IDS = new Set(TECHNICAL_ANALYSIS_TABS.map((t) => t.id));

export function isTechnicalAnalysisPage(page) {
  return TA_IDS.has(page);
}

const DEFAULT_TA_PAGE = 'dashboard';

function Navigation({ currentPage, onPageChange }) {
  const onTechnicalAnalysis = isTechnicalAnalysisPage(currentPage);
  const onMacroIndicators = MACRO_INDICATORS_PAGES.has(currentPage);

  const handleTechnicalAnalysisClick = () => {
    if (!onTechnicalAnalysis) {
      onPageChange(DEFAULT_TA_PAGE);
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-tabs nav-tabs--primary">
        <button
          type="button"
          className={`nav-tab ${onTechnicalAnalysis ? 'active' : ''}`}
          onClick={handleTechnicalAnalysisClick}
          aria-expanded={onTechnicalAnalysis}
        >
          Technical Analysis
        </button>
        {TOP_LEVEL_TABS.map(({ id, label, icon }) => {
          const active =
            id === 'bond-investing' ? onMacroIndicators : currentPage === id;
          return (
            <button
              key={id}
              type="button"
              className={`nav-tab ${active ? 'active' : ''}`}
              onClick={() => onPageChange(id)}
            >
              {icon} {label}
            </button>
          );
        })}
      </div>

      {onMacroIndicators && (
        <div
          className="nav-tabs nav-tabs--secondary"
          role="tablist"
          aria-label="Macro Indicators"
        >
          {MACRO_INDICATORS_TABS.map(({ id, label, icon }) => (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={currentPage === id}
              className={`nav-tab nav-tab--sub ${currentPage === id ? 'active' : ''}`}
              onClick={() => onPageChange(id)}
            >
              {icon} {label}
            </button>
          ))}
        </div>
      )}

      {onTechnicalAnalysis && (
        <div className="nav-tabs nav-tabs--secondary" role="tablist" aria-label="Technical Analysis">
          {TECHNICAL_ANALYSIS_TABS.map(({ id, label, icon }) => (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={currentPage === id}
              className={`nav-tab nav-tab--sub ${currentPage === id ? 'active' : ''}`}
              onClick={() => onPageChange(id)}
            >
              {icon} {label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}

export default Navigation;
